import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { useDatePicker } from '../DatePickerContext';
export const DatePickerOverlay = () => {
    const { disclosureProps: { isOpen }, } = useDatePicker();
    return (_jsx(Box, { position: "fixed", left: "0px", top: "0px", width: "100vw", height: "$100vh", display: isOpen ? 'block' : 'none', "aria-hidden": true, bg: "transparent" }));
};
